var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dropdown",attrs:{"id":_vm.id}},_vm._l((_vm.itemsFiltered),function(item,i){return _c('li',{key:`i-${i}`,attrs:{"data-value":item.Ref}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onSelect(item.Ref)}}},[_vm._v(" "+_vm._s(_vm.itemName(item))+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }